import(/* webpackMode: "eager" */ "/home/deploy/apps/front/src/app/fahrzeugkaufen/page.tsx");
